 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import graphql from 'babel-plugin-relay/macro'
import React, {useMemo, useRef} from 'react'
import {useFragment} from 'react-relay'
import useAtmosphere from '~/hooks/useAtmosphere'
import useRouter from '~/hooks/useRouter'
import useSearchFilter from '~/hooks/useSearchFilter'
import {FilterLabels} from '~/types/constEnums'
import constructFilterQueryParamURL from '~/utils/constructFilterQueryParamURL'
import {useQueryParameterParser} from '~/utils/useQueryParameterParser'





import DropdownMenuLabel from './DropdownMenuLabel'
import {EmptyDropdownMenuItemLabel} from './EmptyDropdownMenuItemLabel'
import Menu from './Menu'
import MenuItem from './MenuItem'
import {SearchMenuItem} from './SearchMenuItem'






const UserDashTeamMemberMenu = (props) => {
  const {history} = useRouter()
  const {menuProps, viewer: viewerRef} = props

  const viewer = useFragment(
    graphql`
      fragment UserDashTeamMemberMenu_viewer on User {
        id
        teams {
          id
          name
          teamMembers(sortBy: "preferredName") {
            userId
            preferredName
          }
        }
      }
    `,
    viewerRef
  )

  const atmosphere = useAtmosphere()
  const {userIds, teamIds, showArchived} = useQueryParameterParser(atmosphere.viewerId)

  const oldTeamsRef = useRef([])
  const nextTeams = _nullishCoalesce(_optionalChain([viewer, 'optionalAccess', _ => _.teams]), () => ( oldTeamsRef.current))
  if (nextTeams) {
    oldTeamsRef.current = nextTeams
  }
  const teams = oldTeamsRef.current

  const showAllTeamMembers = !!teamIds
  const {filteredTeamMembers, defaultActiveIdx} = useMemo(() => {
    const filteredTeams = teamIds ? teams.filter(({id: teamId}) => teamIds.includes(teamId)) : teams
    const keySet = new Set()
    const filteredTeamMembers = [] 



    const teamMembers = filteredTeams.map(({teamMembers}) => teamMembers.flat()).flat()
    teamMembers.forEach((teamMember) => {
      const userKey = teamMember.userId
      if (!keySet.has(userKey)) {
        keySet.add(userKey)
        filteredTeamMembers.push(teamMember)
      }
    })
    filteredTeamMembers.sort((a, b) => (a.preferredName > b.preferredName ? 1 : -1))
    return {
      filteredTeamMembers,
      defaultActiveIdx:
        filteredTeamMembers.findIndex((teamMember) => _optionalChain([userIds, 'optionalAccess', _2 => _2.includes, 'call', _3 => _3(teamMember.userId)])) +
        (showAllTeamMembers ? 2 : 1)
    }
  }, [teamIds, userIds])

  const {
    query,
    filteredItems: matchedFilteredTeamMembers,
    onQueryChange
  } = useSearchFilter(filteredTeamMembers, (item) => item.preferredName)

  return (
    React.createElement(Menu, {
      keepParentFocus: true,
      ariaLabel: 'Select the team member to filter by',
      ...menuProps,
      defaultActiveIdx: defaultActiveIdx,}

      , React.createElement(DropdownMenuLabel, null, 'Filter by team member:')
      , filteredTeamMembers.length > 5 && (
        React.createElement(SearchMenuItem, { placeholder: "Search team members"  , onChange: onQueryChange, value: query,} )
      )
      , query && matchedFilteredTeamMembers.length === 0 && (
        React.createElement(EmptyDropdownMenuItemLabel, { key: "no-results",}, "No team members found!"

        )
      )
      , query === '' && showAllTeamMembers && (
        React.createElement(MenuItem, {
          key: 'teamMemberFilterNULL',
          label: FilterLabels.ALL_TEAM_MEMBERS,
          onClick: () => history.push(constructFilterQueryParamURL(teamIds, null, showArchived)),}
        )
      )
      , matchedFilteredTeamMembers.map((teamMember) => (
        React.createElement(MenuItem, {
          key: `teamMemberFilter${teamMember.userId}`,
          dataCy: `team-member-filter-${teamMember.userId}`,
          label: teamMember.preferredName,
          onClick: () =>
            history.push(constructFilterQueryParamURL(teamIds, [teamMember.userId], showArchived))
          ,}
        )
      ))
    )
  )
}

export default UserDashTeamMemberMenu
